import moment from 'moment';

// Accepts the date shapes the backend actually sends: raw numbers like
// "20260601" (ORP_GNR_TRANSLOG.TRN_DATE), "dd/MM/yyyy" (my_orp), ISO strings,
// and .NET "MM/dd/yyyy hh:mm:ss" reader output. DD/MM is listed before MM/DD
// on purpose — the backend's formatted dates are day-first.
const INPUT_FORMATS = [
  'YYYYMMDD',
  'DD/MM/YYYY',
  'DD/MM/YYYY HH:mm:ss',
  'YYYY-MM-DD',
  'YYYY-MM-DDTHH:mm:ss',
  // .NET DateTime.ToString() (US culture): "5/29/2025 12:00:00 AM"
  'M/D/YYYY h:mm:ss A',
  'M/D/YYYY',
  'MM/DD/YYYY HH:mm:ss',
  'DD-MMM-YY',
  'DD MMM YYYY' // already formatted — keeps the function idempotent
];

// "01 Jun 2026" — returns the original value untouched if it can't be parsed
export const formatDate = (value) => {
  if (value === null || value === undefined || value === '') return value;
  const m = moment(String(value).trim(), INPUT_FORMATS, true);
  return m.isValid() ? m.format('DD MMM YYYY') : value;
};
